module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-navigation"
  }, [_c('container', [_c('div', {
    staticClass: "sub-navigation__content"
  }, [_c('ul', [_vm._l((_vm.items), function(item, index) {
    return [_c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": item.to
      }
    }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])], 1)]
  })], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ee7fd8f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubNavigation.vue
// module id = 1659
// module chunks = 2